/* eslint-disable */

export enum Platform {
  PLATFORM_UNSPECIFIED = "PLATFORM_UNSPECIFIED",
  PLATFORM_ANDROID = "PLATFORM_ANDROID",
  PLATFORM_CONTENTFUL = "PLATFORM_CONTENTFUL",
  PLATFORM_IOS = "PLATFORM_IOS",
  PLATFORM_MESSAGING = "PLATFORM_MESSAGING",
  PLATFORM_POLYREPO = "PLATFORM_POLYREPO",
  PLATFORM_TREEHOUSE = "PLATFORM_TREEHOUSE",
  PLATFORM_WEB = "PLATFORM_WEB",
}

export interface TranslationMessage {
  client_key?: string;
  context?: string;
  path?: string;
  text?: string;
  version_key?: string;
}

export interface LocaleToTranslationMessages {
  locale?: string;
  messages?: TranslationMessage[];
}

/** Eventing */
export interface TranslationCompleteEvent {
  project_name?: string;
  locale?: string;
}

export interface SubmitTranslationsRequestMetadata {
  commit_sha?: string;
  url?: string;
}

export interface SubmitTranslationsRequest {
  project_name?: string;
  platform?: string;
  messages_to_translate?: TranslationMessage[];
  request_metadata?: SubmitTranslationsRequestMetadata;
  /** @deprecated */
  target_locales?: string[];
}

export interface SubmitTranslationsResponse {
}

export interface RetrieveTranslationsRequest {
  project_name?: string;
  platform?: string;
  last_pull_time_millis?: number;
  messages_to_retrieve?: TranslationMessage[];
  target_locales?: string[];
}

export interface RetrieveTranslationsResponse {
  translated_messages?: LocaleToTranslationMessages[];
}

/** Retrieve All Translations */
export interface RetrieveAllTranslationsRequest {
  project_name?: string;
  platform?: string;
  last_pull_time_millis?: number;
}

export interface RetrieveAllTranslationsResponse {
  translated_messages?: LocaleToTranslationMessages[];
}

export interface LocaleStatus {
  locale?: string;
  status?: string;
}

export interface TranslationStatus {
  commit_sha?: string;
  status?: string;
  locale_statuses?: LocaleStatus[];
}

export interface GetTranslationsStatusesRequest {
  project_name?: string;
  platform?: string;
}

export interface GetTranslationsStatusesResponse {
  project_name?: string;
  statuses?: TranslationStatus[];
}

export interface UpdateTranslationRequest {
  project_name?: string;
  platform?: string;
  /** client_key is passed in here to identify a translation key in a project */
  key?: string;
  locale?: string;
  old_text?: string;
  new_text?: string;
}

export interface UpdateTranslationResponse {
  num_updates?: number;
}

export interface TranslationUpdatedEvent {
  project_name?: string;
  platform?: string;
  client_key?: string;
  version_key?: string;
  old_text?: string;
  new_text?: string;
  locale?: string;
  caller?: string;
}

/** Only for testing TO DO @lynnea remove after verification */
export interface PublishTranslationCompleteEventRequest {
  project_name?: string;
  locale?: string;
}

export interface PublishTranslationCompleteEventResponse {
}

export interface SeedDevelopmentDataRequest {
  project_count?: number;
}

export interface SeedDevelopmentDataResponse {
}

export interface CashLingoCoreService {
  SubmitTranslations(request: SubmitTranslationsRequest): Promise<SubmitTranslationsResponse>;
  RetrieveAllTranslations(request: RetrieveAllTranslationsRequest): Promise<RetrieveAllTranslationsResponse>;
  RetrieveTranslations(request: RetrieveTranslationsRequest): Promise<RetrieveTranslationsResponse>;
  GetTranslationsStatuses(request: GetTranslationsStatusesRequest): Promise<GetTranslationsStatusesResponse>;
  UpdateTranslation(request: UpdateTranslationRequest): Promise<UpdateTranslationResponse>;
  PublishTranslationCompleteEvent(
    request: PublishTranslationCompleteEventRequest,
  ): Promise<PublishTranslationCompleteEventResponse>;
  SeedDevelopmentData(request: SeedDevelopmentDataRequest): Promise<SeedDevelopmentDataResponse>;
}
